import React, { useEffect, useRef, useState } from 'react';
import '../styles/OurSchool.css';
import pic1 from "../assets/icon (1).png";
import pic2 from "../assets/icon (2).png";
import pic3 from "../assets/icon (3).png";
import pic4 from "../assets/icon (4).png";

const stats = [
  { icon: pic2, target: 50, label: 'Classrooms', suffix: '+' },
  { icon: pic4, target: 56, label: 'Faculty members', suffix: '+' },
  { icon: pic1, target: 6, label: 'Labs', suffix: '+' },
  { icon: pic4, target: 1325, label: 'Students', suffix: '+' },
  { icon: pic3, target: 1000, label: 'Books in library', suffix: '+' },
];

const Counter = ({ target, suffix }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 2000;
          const steps = 60;
          const increment = target / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <span ref={ref}>
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};

const OurSchoolPage = () => {
  return (
    <div className="glb-ourschool-wrapper">

      {/* Stats Counter Section */}
      <div className="glb-stats-section">
        <div className="glb-stats-wrapper">
          <h2 className="glb-stats-heading">AT A GLANCE</h2>
          <p className="glb-stats-subheading">
            Numbers that reflect our commitment to excellence
          </p>

          <div className="glb-stats-row">
            {stats.map((stat, index) => (
              <div className="glb-stat-card" key={index}>
                <div className="glb-stat-icon">
                  <img src={stat.icon} alt="icon" />
                </div>
                <div className="glb-stat-number">
                  <Counter target={stat.target} suffix={stat.suffix} />
                </div>
                <div className="glb-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  );
};

export default OurSchoolPage;